// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-X":"X_dpu-detail-X__dZB2Y"};